import store from '../vuex/store';
import router from '../router';
import md5 from 'blueimp-md5';

window.inArray = function(needle, haystack)
{
    if ( ! (haystack instanceof Array)) throw 'window.inArray: haystack is not an Array';

    return haystack.indexOf(needle) !== -1;
};

window.isset = function(val)
{
    if (typeof val == 'undefined') return false;
    if (val == null) return false;
    return true;
};

const ONDURO = {};

ONDURO.install = function(Vue, options)
{
    let methods =
    {
        /*
         * App Ready Function
         *
         * This function ensures, that the "current" store is fully initialized
         * for usage in the routes "beforeEnter" hook.
         */
        isReady(callback)
        {
            if (store.state.app.ready) {
                callback();
                return;
            }

            setTimeout(() => {
                if (store.state.app.ready) {
                    callback();
                    return;
                }

                this.isReady(callback);
            }, 200);
        },

        /*
         *  Check if current membership is in the shadow
         */
        isShadow: function()
        {
            return store.state.current.membership.shadow;
        },

        /*
         *  Check if current membership is not in the shadow
         */
        isReal: function()
        {
            return ! this.isShadow();
        },

        /*
         *  Check if current account has (any) certain module(s)
         *
         *  Usage:
         *  $onduro.hasModule('some_role')                        // string
         *  $onduro.hasModule(['any', 'of', 'these', 'modules'])  // array
         */
        hasModule: function(identifier)
        {
            let modules = store.state.current.account.modules;

            if (identifier instanceof Array)
            {
                return _.intersection(identifier, modules).length;
            }
            else
            {
                return inArray(identifier, modules);
            }
        },

        /*
         *  Check if current user has ANY certain role(s)
         *
         *  Usage:
         *  $onduro.hasRole('some_role')                        // string
         *  $onduro.hasRole('this_role', 'or_this_one')         // arguments
         *  $onduro.hasRole(['any', 'of', 'these', 'roles'])    // array
         */
        hasRole: function()
        {
            let roles = store.state.current.membership.roles;

            let identifiers = arguments;

            if (identifiers.length == 1)
            {
                if (arguments[0] instanceof Array)
                {
                    identifiers = arguments[0];
                }
                else
                {
                    return inArray(arguments[0], roles);
                }
            }

            let hasRole = false;
            _.forOwn(identifiers, (identifier) =>
            {
                if (inArray(identifier, roles)) hasRole = true;
            });

            return hasRole;
        },

        isSkoUser()
        {
        	if (store.state.current.user.email.indexOf('@onduro.com') !== -1) return true;
            return store.state.current.account.sko && store.state.current.user.email.indexOf('@sk-office.net') !== -1;
        },

        shorten(text, max = 30, suffix = '...')
        {
            let chars = (window.innerWidth * max / 100) / 40 * 4;
            return (text.length > chars) ? text.substr(0, chars - 3) + suffix : text;
        },

        hasRight: function(identifier)
        {
            let rights = store.state.current.membership.rights;

            return inArray(identifier, rights);
        },

        getConfig: function(identifier)
        {
            return store.state.current.account.config[identifier];
        },

        getPreference: function(identifier)
        {
            return store.state.current.membership.preferences[identifier];
        },

        redirect(name, params)
        {
            router.push(this.route(name, params));
        },

        route(path, params, lang)
        {
            lang = lang || Vue.config.lang;

            let name = path.replace('/', '.');

            params = (params) ? '/' + params : '';

            if (name == 'login') name = 'login.signin';

            var translation = _getTranslation('route.' + name + '.path', lang);

            if (translation !== false)
            {
                // remove params from translation
                translation = translation.split('/:')[0];

                return '/' + lang + '/' + translation + params;
            }

            return '/' + lang + '/' + path + params;
        },

        // returns the translated route path from any given (invalid) path
        translatedRoutePath(route, lang)
        {
            let name = route.name;

            if ( ! name) return '/' + lang;

            if (name == 'login') name = 'login.signin';

            var translatedPath = '/:lang/' + _getTranslation('route.' + name + '.path', lang);

            if (translatedPath)
            {
                var segments = route.path.split('/');
                var params = route.matched.slice(-1)[0].path.split('/'); // take last matched route
                var translated = translatedPath.split('/');

                var path = params.map((segment, index) => {
                    if (segment.indexOf(':') === 0) {
                        return segments[index];
                    } else {
                        return translated[index];
                    }
                });

                return path.join('/');
            }

            return this.route(name);
        },

        /**
         * Decorator for $store[cache/temp:write]
         *
         * @param key
         * @param payload
         * @param temp
         */
        writeCache(key, payload, temp)
        {
            let _store = (temp)? 'temp' : 'cache';

            store.dispatch(_store + '/write', {
                key: key,
                payload: payload,
            });
        },

        /**
         * Remove observer from object to clear reactivity
         *
         * @param obj
         */
        untrack(obj)
        {
            return JSON.parse(JSON.stringify(obj));
        },

        /**
         * Compare to vue objects
         *
         * @param a
         * @param b
         * @returns {boolean}
         */
        compare(a, b)
        {
            return (
                md5(JSON.stringify(_.map(a, (n) => { return (n == '')? null : n ; }))) ==
                md5(JSON.stringify(_.map(b, (n) => { return (n == '')? null : n ; })))
            );
        },

        /**
         * Convert minutes having unit to number in minutes
         */
        timeToNumber(val)
        {
            if ( ! val) return 0;

            let num = val.toString();

            if (num.indexOf(':') != -1)
            {
                let segments = num.split(':');
                num = parseInt(segments[0]) * 60 + parseInt(segments[1]);
            }
            else if (val.toString().toLowerCase().indexOf('h') != -1 && val.toString().toLowerCase().indexOf('m'))
            {
                //@TODO split string and calculate
            }
            else num = parseInt(num);

            return num || 0;
        },

        numberToTime(val)
        {
            let hours = val / 60,
                minutes = val % 60;

            hours = (val > 0) ? Math.floor(hours) : Math.ceil(hours);

            return ((hours < 10)? `0${hours}` : hours ) + ':' + ((minutes < 10)? `0${minutes}` : minutes );
        },

        makeDuration(time)
        {
            return (time.end < time.start) ? (time.end || 0) - (time.start || 0) - (time.break || 0) + 1440 : (time.end || 0) - (time.start || 0) - (time.break || 0);
        },

        /**
         * convert time to time string 00 h 00 m
         * @param val
         * @returns {string}
         */
        totalString(val)
        {
            let hours = val / 60,
                minutes = val % 60;

            hours = (val > 0) ? Math.floor(hours) : Math.ceil(hours);

            return hours + ' h ' + minutes + ' m';
        },

        /**
         * Translate current route to defined language
         *
         * @param lang
         * @returns {string}
         */
        switchLanguage(lang, replace)
        {
            // make sure locales are loaded
            if (lang === 'de') {
                // Use the extended German locale file with country translations
                Vue.locale(lang, require('../lang/locales.countries.de.js').default);
            } else if (lang === 'nl') {
                // Use the extended Dutch locale file with country translations
                Vue.locale(lang, require('../lang/locales.countries.nl.js').default);
            } else {
                Vue.locale(lang, require('../lang/locales.' + lang).default);
            }

            document.querySelector('meta[name=description]').setAttribute('content', Vue.t('meta.description'));

            let name = router.app.$route.name,
                params = router.app.$route.params,
                translation = _getTranslation('route.' + name + '.path', lang);

            // standard route
            let route =  '/' + lang + '/' + name;

            if (translation !== false)
            {
                if (params)
                {
                    // make sure to replace params, such as :id in the translated url
                    _.forIn(params, (value, key) =>
                    {
                        translation = translation.replace(':' + key, value);
                    });
                }

                route = '/' + lang + '/' + translation;
            }

            if (replace) router.replace(route);
            return route;
        },
    };

    // private methods
    function _getTranslation(key, lang)
    {
        if ( ! lang) lang = Vue.config.lang;

        // translation does not exist for this language
        if (['en', 'de', 'nl', 'pl'].indexOf(lang) == -1) return false;

        let locales;
        if (lang === 'de') {
            // Use the extended German locale file with country translations
            locales = require('../lang/locales.countries.de.js').default;
        } else if (lang === 'nl') {
            // Use the extended Dutch locale file with country translations
            locales = require('../lang/locales.countries.nl.js').default;
        } else {
            locales = require('../lang/locales.' + lang).default;
        }

        var translation = key.split('.').reduce((o,i) =>
        {
            if (o === false) return false;

            if (i in o) {
                return o[i];
            } else {
                return false;
            }
        }, locales);

        return translation;
    }

    // register global methods
    Vue.onduro = methods;

    // instance methods
    Vue.prototype.$onduro = methods;

    // register global assets
    // Vue.directive('my-directive', {});

    // register global mixins
    // Vue.mixin({ methods: ... });
};

export default ONDURO;



// WEBPACK FOOTER //
// ./src/js/plugins/onduro.js